import styled from 'styled-components';

const CenterChild = styled.div({
  display: 'flex',
  justifyContent: 'center',
  flex: 1,
});

export default CenterChild;
